module.exports = __webpack_public_path__ + "static/media/guide_incorrect_1.d157ea32.png";